export default __webpack_public_path__ + "static/media/ep_11.1bbe1ab7.png";